import { trackAnalyticsEvent } from '../../utils/track-analytics-event.js';

class RefiAppTimeout extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.timer = 1800000;
    this.timeoutUrl = '/';
    this.resetTimer = () => {
      window.clearTimeout(this.appTimeout);
      this.setAppTimeout();
    };
  }

  static get observedAttributes() {
    return ['clear-session', 'timeout-url', 'timer'];
  }

  connectedCallback() {
    this.shadowRoot.innerHTML = '<slot></slot>';
    this.setAppTimeout();
    document.addEventListener('keydown', this.resetTimer);
    document.addEventListener('click', this.resetTimer);
  }

  disconnectedCallback() {
    window.clearTimeout(this.appTimeout);
    document.removeEventListener('keydown', this.resetTimer);
    document.removeEventListener('click', this.resetTimer);
  }

  attributeChangedCallback(name, oldValue, newValue) {
    switch (name) {
      case 'clear-session':
        this.clearSession = newValue;
        break;
      case 'timeout-url':
        this.timeoutUrl = newValue;
        break;
      case 'timer':
        this.timer = newValue;
        break;
      // no default case
    }
  }

  setAppTimeout() {
    this.appTimeout = window.setTimeout(() => {
      trackAnalyticsEvent('timeout');
      if (this.clearSession && sessionStorage.getItem(this.clearSession)) {
        sessionStorage.removeItem(this.clearSession);
      }
      window.open(this.timeoutUrl, '_self');
    }, this.timer);
  }
}

export { RefiAppTimeout };
